import React, { Component } from "react";
import {
	Form,
	Input,
	Select,
	Button,
	message,
	DatePicker,
	Progress,
	Checkbox,
} from "antd";
import "./queryTable.scss";
import moment from "moment";
import {
	getTypicalCasesBaseInfo,
	getTypicalCasesList,
	getPatientSourceList,
	getWaitImprovedList,
	applyExportList,
	getTranquillizationBloodList,
	exportTranquillizationBloodList,
} from "@/request/api";
import { refreshTime, requestErrorLog } from "@/common/util";
const { Option } = Select;

class ApplyQueryTable extends Component {
	constructor(props) {
		const settingData = JSON.parse(localStorage.getItem("settingValues"));
		super(props);
		this.state = {
			reportStatus: [],
			consultationStatus: [],
			departmentList: [],
			source: [],
			tableData: [], // 列表数据
			percent: 0,
			applyCount: "ECG",
			RowCount: 0,
			PageNo: 1,
			PageSize: 10,
			refreshTimeNum: 0,
			// 开始日期-结束日期
			defaultSelectDate: {
				startDate: moment()
					.startOf("day")
					.subtract(settingData && settingData.consulation - 1, "days"),
				endDate: moment().endOf(-1, "day"),
			},
			checkbockval: "",
			canRefresh: false,
			searchObj: {
				queryData: "ECG",
			},
			tableKeys: this.props.data,
			criticalIsTop: 0,
		};
	}

	componentDidMount() {
		this.allBasicData();
		this.initQueryList();
		this.props.getMessageFn();
		this.props.onRef(this);
		let refreshTimeNum = refreshTime(this);
		this.setState(
			{
				refreshTimeNum,
			},
			() => {
				this.refreshTimer = setInterval(
					() => refreshTime(this, this.initQueryList),
					(this.state.refreshTimeNum * 1000 * 60) / 200
				);
			}
		);
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			nextProps.data !== this.state.tableKeys &&
			nextProps.data !== nextState.tableKeys
		) {
			this.setState(
				{
					tableKeys: nextProps.data,
					PageNo: 1,
					PageSize: 10,
				},
				() => {
					this.initQueryList(nextProps.data);
				}
			);
		}
		if (
			nextProps.PageNo !== this.props.PageNo ||
			nextProps.PageSize !== this.props.PageSize
		) {
			this.setState(
				{
					PageNo: nextProps.PageNo,
					PageSize: nextProps.PageSize,
				},
				() => {
					this.initQueryList(this.state.tableKeys);
				}
			);
		}
		return true;
	}

	componentWillUnmount() {
		clearInterval(this.refreshTimer);
	}

	allBasicData = () => {
		//患者来源
		let params = { pageNo: 1, pageSize: 10, NAME: "" };
		getPatientSourceList(params).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					source: res.Result.dataList,
				});
			} else {
				requestErrorLog('', '远程申请查询来源列表接口报错', 0, true)
			}

		});
		getTypicalCasesBaseInfo().then((res) => {
			if (res && res.Status === 1) {
				const basicsdata = res.Result.basicsdata;
				const department = res.Result.department;
				for (var i = 0; i < basicsdata.length; i++) {
					if (basicsdata[i].name === "状态") {
						const statusList = basicsdata[i].dt;
						this.setState({
							reportStatus: statusList,
						});
					}
					if (basicsdata[i].name === "会诊状态") {
						const status = basicsdata[i].dt;
						this.setState({
							consultationStatus: status,
						});
					}
				}
				for (var s = 0; s < department.length; s++) {
					const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
					if (userInfo.HOSPITAL_NAME === department[s].name) {
						const departmentList = department[s].dept;
						this.setState({
							departmentList: departmentList,
						});
					}
				}
			} else {
				requestErrorLog('', '远程申请查询基础数据口报错', 0, true)
			}
		});
	};

	initQueryList = (tableKeys, isExport, obj) => {
		//获取列表数据
		const { searchObj } = this.state;
		let tabskeyws = this.state.tableKeys.toString();
		switch (parseInt(tableKeys) || parseInt(tabskeyws)) {
			case 1:
				searchObj.queryData = "ECG"; // 静息心电
				this.handleHospitalSubmit(searchObj, isExport, obj);
				break;

			case 2:
				searchObj.queryData = "Holter"; // 动态心电
				this.handleHospitalSubmit(searchObj, isExport, obj);
				break;

			case 3:
				searchObj.queryData = "BloodPressure"; // 动态血压
				this.handleHospitalSubmit(searchObj, isExport, obj);
				break;

			case 4:
				this.waitImprovedList(isExport, obj); //院内待检查
				break;
			case 5:
				searchObj.queryData = "EEG"; // 动态血压
				this.handleHospitalSubmit(searchObj, isExport, obj);
				break;
			case 6:
				this.getTranquillizationBloodList(isExport, obj);
				break;
			default:
				break;
			// default:
			//   searchObj.queryData = "ECG"    // 静息心电
			//   break;
		}
		// this.handleHospitalSubmit(searchObj);
	};

	searchListFn = () => {
		this.setState(
			{
				PageNo: 1,
				PageSize: 10,
			},
			() => {
				this.initQueryList();
			}
		);
	};

	waitImprovedList = () => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		this.props.form.validateFields((err, values) => {
			if (!err) {
				let params = {
					Type: "SELECT",
					HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
					PageNo: this.state.PageNo,
					PageSize: this.state.PageSize,
					FILE_UID: values.FILE_UID,
					NAME: values.NAME,
					EXAM_DATETIME: [
						moment(values.startTime).format("YYYY-MM-DD"),
						moment(values.endTime).format("YYYY-MM-DD"),
					],
				};
				getWaitImprovedList(params).then((res) => {
					if (res.Status === 1) {
						let data = res.Result;
						let RowCount = res.ResponseModel.RowCount;
						this.props.getData(
							data,
							RowCount,
							this.state.PageNo,
							this.state.PageSize,
							false
						);
					} else {
						requestErrorLog('', '远程申请院内待检查列表接口报错', 0, true)
					}
				});
			}
		});
	};

	handleHospitalSubmit = (searchObj, isExport, obj) => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const custService = JSON.parse(localStorage.getItem('QUERY_ALL'));//客服权限可以删除
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (values.startTime > values.endTime) {
					message.error("开始时间不得大于结束时间");
					return;
				}
				let params = {
					Type: "ApplyData", // 查询
					hospital_Code: userInfo.HOSPITAL_CODE,
					EXAM_CLASS: searchObj.queryData, // 静息心电、动态心电、动态血压
					hospitalPatientName: values.hospitalPatientName || "",
					hospitalReportStatus: values.hospitalReportStatus || "",
					CONSULTATION_STATUS: values.CONSULTATION_STATUS, //会诊状态
					hospitalDoctor: values.hospitalDoctor || "",
					hospitalNumber: values.hospitalNumber || "",
					hospitalItemNumber: values.hospitalItemNumber || "",
					hospitalApplyDepartment: values.hospitalApplyDepartment || "",
					hospitalApply: values.hospitalApply || "",
					hospitalItemApply: values.hospitalItemApply || "",
					hospitalPatientSource: values.hospitalPatientSource || "",
					hospitalDateTime: values.hospitalDateTime || "",
					hospitalItemDoctor: values.hospitalItemDoctor || "",
					hospitalConclusion: values.hospitalConclusion || "",
					hospitalItemDateTime: [
						moment(values.startTime).format("YYYY-MM-DD"),
						moment(values.endTime).format("YYYY-MM-DD"),
					],
					PageNo: this.state.PageNo,
					PageSize: this.state.PageSize,
					EXIT_FLAG: this.state.checkbockval,
					QUERY_ALL: custService === 1 ? 1 : 0, //客服名称
					IS_TOP: this.state.criticalIsTop, // 0不勾选 1勾选
				};
				if (isExport) {
					delete params.PageNo;
					delete params.PageSize;
					delete params.Type;

					params.EXPORT_COLUMN = obj.name;
					params.EXPORT_DATA = obj.index;

					applyExportList(params).then((res) => {
						if (res && res.Status === 1) {
							window.location.href = window.g.baseURL + "/" + res.Result;
						} else {
							requestErrorLog('', '远程申请导出接口报错', 0, true)
							message.error("导出失败，请稍后重试");
						}
					});
				} else {
					getTypicalCasesList(params).then((res) => {
						this.setState({
							canRefresh: false,
						});
						if (res && res.Status === 1) {
							const data = res.Result;
							let RowCount = res.ResponseModel.RowCount;
							this.setState({
								tableData: data,
								RowCount: RowCount,
							});
							this.props.getData(
								data,
								RowCount,
								this.state.PageNo,
								this.state.PageSize,
								false
							);
							this.handleApplyCount(params);
							//获取消息接口放在这里是为了刷新数据列表可以及时接收新消息提醒
							this.props.getMessageFn();
						} else {
							requestErrorLog('', '远程申请列表接口报错', 0, true)
							message.error("请检查网络连接");
						}
					});
				}
			}
		});
	};
	getTranquillizationBloodList = (isExport, obj) => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (values.startTime > values.endTime) {
					message.error("开始时间不得大于结束时间");
					return;
				}
				let params = {
					PageNo: this.state.PageNo,
					PageSize: this.state.PageSize,
					ID_NUMBER: values.hospitalItemNumber,
					NAME: values.PatientName,
					EXAM_DATETIME: [
						moment(values.startTime).format("YYYY-MM-DD"),
						moment(values.endTime).format("YYYY-MM-DD"),
					],
					HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
				};
				this.setState({
					canRefresh: false,
				});
				if (isExport) {
					delete params.PageNo;
					delete params.PageSize;
					delete params.Type;

					params.EXPORT_COLUMN = obj.name;
					params.EXPORT_DATA = obj.index;

					exportTranquillizationBloodList(params).then((res) => {
						console.log(res);
						if (res && res.Status === 1) {
							window.location.href = window.g.baseURL + "/" + res.Result;
						} else {
							message.error("导出失败，请稍后重试");
							requestErrorLog('', '远程申请导出常规血压列表接口报错', 0, true)
						}
					});
				} else {
					this.props.getData(
						[],
						0,
						this.state.PageNo,
						this.state.PageSize,
						true
					);
					getTranquillizationBloodList(params).then((res) => {
						// this.setState({ tableData: [], RowCount: 0 });
						if (res && res.Status === 1) {
							console.log(res);
							const data = res.Result;
							let RowCount = res.ResponseModel.RowCount;
							this.setState({
								tableData: data,
								RowCount: RowCount,
							});
							this.props.getData(
								data,
								RowCount,
								this.state.PageNo,
								this.state.PageSize,
								false
							);
						} else {
							requestErrorLog('', '远程申请常规血压列表接口报错', 0, true)
						}
					});
				}
			}
		});
	};

	handleApplyCount = (params) => {
		params.Type = "PATIENT_LocalCount"; //远程申请气泡
		delete params.PageNo;
		delete params.PageSize;
		getTypicalCasesList(params).then((res) => {
			if (res && res.Status === 1) {
				const count = res.Result;
				this.props.setCount(count);
			} else {
				requestErrorLog('', '远程申请未读消息口报错', 0, true)
				message.error("请检查网络连接");
			}
		});
	};

	handleChangeReset = () => {
		this.props.form.resetFields();
		this.setState({
			checkbockval: "",
			criticalIsTop: 0
		});
	};

	// 只能选择今天跟今天之前的日期
	disabledDate(current) {
		return current > moment().subtract(0, "day");
	}
	onReturnChange = (event) => {
		this.setState({
			checkbockval: event.target.checked ? 2 : "",
		});
	};
	onCriticalChange = (event) => {
		this.setState({
			criticalIsTop: event.target.checked ? 1 : 0
		});
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		const {
			reportStatus,
			consultationStatus,
			departmentList,
			source,
			percent,
			defaultSelectDate: { startDate, endDate },
		} = this.state;
		const settingData = JSON.parse(localStorage.getItem("settingValues"));
		return (
			<>
				{parseInt(this.state.tableKeys) === 4 ? (
					<Form
						layout="inline"
						className="commonCase"
						style={{ height: "100px", display: "flex", alignItems: "center" }}>
						<Form.Item label="患者姓名">
							{getFieldDecorator("NAME", { initialValue: "" })(<Input />)}
						</Form.Item>
						<Form.Item label="编码">
							{getFieldDecorator("FILE_UID", { initialValue: "" })(<Input />)}
						</Form.Item>
						<Form.Item label="检查日期" className="mark dateTime">
							{getFieldDecorator("startTime", { initialValue: startDate })(
								<DatePicker
									style={{ width: 125 }}
									allowClear={false}
									placeholder="开始日期"
									disabledDate={this.disabledDate}
								/>
							)}
							<span
								style={{
									display: "inline-block",
									textAlign: "center",
									width: 15,
								}}>
								-
							</span>
							<Form.Item style={{ width: 110 }}>
								{getFieldDecorator("endTime", { initialValue: endDate })(
									<DatePicker
										style={{ width: 125 }}
										allowClear={false}
										placeholder="结束日期"
										disabledDate={this.disabledDate}
									/>
								)}
							</Form.Item>
						</Form.Item>
						<Form.Item className="btn">
							<Button
								style={{ marginRight: "10px" }}
								onClick={() => this.searchListFn()}>
								查询
							</Button>
							<Button onClick={() => this.handleChangeReset()}>重置</Button>
						</Form.Item>
						<div style={{ position: "absolute", left: "60%", top: "10%" }}>
							<Progress
								className="progress"
								type="circle"
								strokeColor="#009d96"
								width={80}
								percent={percent}
								format={(percent) => "自动刷新"}
							/>
						</div>
					</Form>
				) : parseInt(this.state.tableKeys) === 6 ? (
					<Form layout="inline" className="commonCase">
						<div>
							<Form.Item label="患者姓名">
								{getFieldDecorator("PatientName", { initialValue: "" })(
									<Input />
								)}
							</Form.Item>

							<Form.Item
								className="mark"
								style={{ width: "275px" }}
								label={getFieldDecorator("ID_NUMBER", {
									initialValue: "身份证号",
								})(
									<Select>
										<Option value="身份证号">身份证号:</Option>
									</Select>
								)}>
								{getFieldDecorator("hospitalItemNumber", { initialValue: "" })(
									<Input />
								)}
							</Form.Item>
							<Form.Item
								label={getFieldDecorator("hospitalDateTime", {
									initialValue: "检查日期",
								})(
									<Select>
										<Option value="申请日期">检查日期：</Option>
									</Select>
								)}
								className="mark dateTime">
								{getFieldDecorator("startTime", { initialValue: startDate })(
									<DatePicker
										style={{ width: 125 }}
										allowClear={false}
										placeholder="开始日期"
										disabledDate={this.disabledDate}
									/>
								)}
								<span
									style={{
										display: "inline-block",
										textAlign: "center",
										width: 15,
									}}>
									-
								</span>
								<Form.Item style={{ width: 110 }}>
									{getFieldDecorator("endTime", { initialValue: endDate })(
										<DatePicker
											style={{ width: 125 }}
											allowClear={false}
											placeholder="结束日期"
											disabledDate={this.disabledDate}
										/>
									)}
								</Form.Item>
							</Form.Item>
						</div>

						<div style={{ height: 35 }}>
							<Form.Item
								className="btn"
								style={{ position: "absolute", left: "66%", top: "10%" }}>
								<Button
									style={{ marginRight: "10px" }}
									onClick={() => this.searchListFn()}>
									查询
								</Button>
								<Button onClick={() => this.handleChangeReset()}>重置</Button>
							</Form.Item>
							<div style={{ position: "absolute", left: "76%", top: "10%" }}>
								<Progress
									className="progress"
									type="circle"
									strokeColor="#009d96"
									width={80}
									percent={percent}
									format={(percent) => "自动刷新"}
								/>
							</div>
						</div>
					</Form>
				) : (
					<Form layout="inline" className="commonCase">
						<div>
							<Form.Item label="患者姓名">
								{getFieldDecorator("hospitalPatientName", { initialValue: "" })(
									<Input />
								)}
							</Form.Item>
							<Form.Item label="报告状态">
								{getFieldDecorator("hospitalReportStatus", {
									initialValue: "",
								})(
									<Select>
										<Option value="">全部</Option>
										{reportStatus.map((item) =>
											item.DIC_NAME !== "已退回" ? (
												<Option key={item.DIC_CODE} value={item.DIC_CODE}>
													{item.DIC_NAME}
												</Option>
											) : null
										)}
									</Select>
								)}
							</Form.Item>
							<Form.Item label="会诊状态">
								{getFieldDecorator("CONSULTATION_STATUS", { initialValue: "" })(
									<Select>
										<Option value="">全部</Option>
										{consultationStatus.map((item) => (
											<Option key={item.DIC_NAME} value={item.DIC_NAME}>
												{item.DIC_NAME}
											</Option>
										))}
									</Select>
								)}
							</Form.Item>
							<Form.Item
								className="mark"
								style={{ width: "275px" }}
								label={getFieldDecorator("hospitalNumber", {
									initialValue:
										(settingData && settingData.hospitalNumber) || "病历号",
								})(
									<Select>
										<Option value="病历号">病历号:</Option>
										<Option value="住院号">住院号：</Option>
										<Option value="门诊号">门诊号：</Option>
										<Option value="申请号">申请号：</Option>
									</Select>
								)}>
								{getFieldDecorator("hospitalItemNumber", { initialValue: "" })(
									<Input />
								)}
							</Form.Item>
							<Form.Item label="检查结论" className="conclusion">
								{getFieldDecorator("hospitalConclusion", { initialValue: "" })(
									<Input />
								)}
							</Form.Item>
							{/* <Form.Item label="退回病例" className="checkBox">
								{getFieldDecorator("isBack", { valuePropName: "checked" })(
									<Checkbox onChange={this.onReturnChange}></Checkbox>
								)}
							</Form.Item> */}
							<div className="checkedReturn">
								<p>退回病例：</p>
								<Checkbox onChange={this.onReturnChange} checked={this.state.checkbockval}></Checkbox>
							</div>
							<div className="checkedCritical">
								<p>危急病例置顶：</p>
								<Checkbox onChange={this.onCriticalChange} checked={this.state.criticalIsTop}></Checkbox>
							</div>
						</div>

						<div>
							<Form.Item label="申请科室">
								{getFieldDecorator("hospitalApplyDepartment", {
									initialValue: "",
								})(
									<Select>
										<Option value="">全部</Option>
										{departmentList.map((item) => (
											<Option key={item.DEPT_UID} value={item.DEPT_CODE}>
												{item.DEPT_NAME}
											</Option>
										))}
									</Select>
								)}
							</Form.Item>

							<Form.Item label="患者来源">
								{getFieldDecorator("hospitalPatientSource", {
									initialValue: "",
								})(
									<Select>
										<Option value="">全部</Option>
										{source.map((item) => (
											<Option
												key={item.PATIENT_SOURCE_CODE}
												value={item.PATIENT_SOURCE_CODE}>
												{item.PATIENT_SOURCE_NAME}
											</Option>
										))}
									</Select>
								)}
							</Form.Item>
							<Form.Item
								className="mark"
								style={{ width: "300px" }}
								label={getFieldDecorator("hospitalDoctor", {
									initialValue: "申请人",
								})(
									<Select>
										<Option value="申请人">申请人：</Option>
										<Option value="报告人">报告人：</Option>
										<Option value="审核人">审核人：</Option>
										<Option value="开单医生">开单医生：</Option>
									</Select>
								)}>
								{getFieldDecorator("hospitalItemDoctor")(
									<Input placeholder="模糊查询" style={{ width: "180px" }} />
								)}
							</Form.Item>
							<Form.Item
								label={getFieldDecorator("hospitalDateTime", {
									initialValue:
										(settingData && settingData.hospitalDateTime) || "创建日期",
								})(
									<Select>
										<Option value="申请日期">创建日期:</Option>
										<Option value="远程申请日期">申请会诊日期：</Option>
										<Option value="检查日期">检查日期：</Option>
										<Option value="报告日期">报告日期：</Option>
										<Option value="完成会诊日期">完成会诊日期：</Option>
									</Select>
								)}
								className="mark dateTime">
								{getFieldDecorator("startTime", { initialValue: startDate })(
									<DatePicker
										style={{ width: 125 }}
										allowClear={false}
										placeholder="开始日期"
										disabledDate={this.disabledDate}
									/>
								)}
								<span
									style={{
										display: "inline-block",
										textAlign: "center",
										width: 15,
									}}>
									-
								</span>
								<Form.Item style={{ width: 110 }}>
									{getFieldDecorator("endTime", { initialValue: endDate })(
										<DatePicker
											style={{ width: 125 }}
											allowClear={false}
											placeholder="结束日期"
											disabledDate={this.disabledDate}
										/>
									)}
								</Form.Item>
							</Form.Item>
							<Form.Item className="btn">
								<Button
									style={{ marginRight: "10px" }}
									onClick={() => this.searchListFn()}>
									查询
								</Button>
								<Button onClick={() => this.handleChangeReset()}>重置</Button>
							</Form.Item>
							<div style={{ position: "absolute", left: "81%", top: "10%" }}>
								<Progress
									className="progress"
									type="circle"
									strokeColor="#009d96"
									width={80}
									percent={percent}
									format={(percent) => "自动刷新"}
								/>
							</div>
						</div>
					</Form>
				)}
			</>
		);
	}
}

export default Form.create()(ApplyQueryTable);
